export enum StatusEnum {
  NEW = 'new',
  PROCESSING = 'processing',
  BOOSTED = 'boosted',
  TERMINATED = 'terminated',
  CANCELLED = 'canceled',
  REBOOSTED = "reboosted",
}
